'use strict';

angular.module('shiftTraderApp')
  .factory('DayOffLimits', function (ServerUrls, $http, Session, TimeService, $q) {
    var path = ServerUrls.current.railsApi + 'day_off_limits';

    var DayOffLimit = function(values) {
      var A = {};

      A.$setup = function() {
        if (A._type === 'exception') {
          A._target_date_original = A.target_date;
          A.target_date = TimeService.getBeginningOfDayFromDate(A.target_date);
          A._target_date_unix = A.target_date.unix();

        } else {
          A.effective_date = TimeService.getBeginningOfDayFromDate(A.effective_date);

          if (A.ineffective_date) {
            A.ineffective_date = TimeService.getBeginningOfDayFromDate(A.ineffective_date);
          }
        }

        A.created_at_tz = moment(A.created_at).tz(tzn);
        A._created_at_unix = moment(A.created_at).unix();
      };

      angular.extend(A, values);
      var tzn = Session.getTimezone();
      A._type = !_.isNull(A.target_date) ? 'exception' : 'day_of_week';
      A.$setup();

      A.$isException = function() {
        return A._type === 'exception';
      };

      A.$isInEffect = function(dt) {
        if (A.$isException()) {
          return (A.target_date.isSame(dt, 'day'));
        } else {
          return dt.day() === A.day_of_week && (_.isNull(A.effective_date) || A.effective_date.isBefore(dt) || A.effective_date.isSame(dt, 'second')) &&
            (_.isNull(A.ineffective_date) || (A.ineffective_date.isAfter(dt) && !A.ineffective_date.isSame(dt, 'day')));
        }
      };

      A.$getLatestMessage = function() {
        if (A.data && A.data.messages && A.data.messages.length > 0) {
          return _.last(A.data.messages);
        } else {
          return null;
        }
      };

      A.$addMessage = function(text) {
        return $http.put(path + '/' + A.id, {
          day_off_limit: {
            message: text
          }
        })
          .then(function(record) {
            A.data = record.data;
            return A;
          }, function(response) {
            return $q.reject(response);
          })
      };

      A.$remove = function() {
        return $http.put(path + '/' + A.id, {
          active: false,
          was_removed: true
        })
          .then(function(record) {
            A.active = record.active;
            A.inactive_at = record.inactive_at;
            A.inactive_by_id = record.inactive_by_id;
            A.was_removed = record.was_removed;
            return A;
          }, function(response) {
            return $q.reject(response);
          });
      };

      return A;
    };


    var DayOffLimits = {};

    DayOffLimits.initWithData = function(data) {
      return new DayOffLimit(data);
    };

    DayOffLimits.getHistoryForDate = function(dtMoment, optionalStartDate) {
      var config = {
        params: {}
      };

      if (optionalStartDate) {
        config.params.start_date = optionalStartDate.format('YYYY-MM-DD')
      }

      return $http.get(path + '/history/' + dtMoment.format('YYYY-MM-DD'), config)
        .then(function(response) {
          return _.map(response.data, function(datum) {
            return new DayOffLimit(datum);
          });
        }, function(response) {
          return $q.reject(response);
        });
    };

    DayOffLimits.getAll = function(options) {
      var config = {
        params: {}
      };

      if (angular.isDefined(options)) {
        angular.extend(config.params, options);
      }
      return $http.get(path, config)
        .then(function(response) {
          return _.map(response.data, function(datum) {
            return DayOffLimits.initWithData(datum);
          });
        }, function(response) {
          return $q.reject(response);
        });
    };

    DayOffLimits.create = function(data) {
      var newData = {
        day_off_limit: data
      };

      return $http.post(path, newData)
        .then(function(response) {
          return DayOffLimits.initWithData(response.data);
        }, function(response) {
          return $q.reject(response);
        })
    };

    return DayOffLimits;
  });
